import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const getAlunos = async () => {
  const url = API_CONSTANT_MAP.aluno;
  return requestApi.get(url);
};

export const postAluno = (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.aluno, payload);
};

export const getAlunoById = async (id: string) => {
  const url = `${API_CONSTANT_MAP.aluno}/${id}`;
  return requestApi.get(url);
};

/** Exclusão física do aluno e de toda a matrícula. Só o perfil MASTER é aceito pela API. */
export const deleteAluno = async (id: number) => {
  const url = `${API_CONSTANT_MAP.aluno}/${id}`;
  return requestApi.delete(url);
};

export const getAlunoCabines = async () => {
  const url = `${API_CONSTANT_MAP.aluno}/cabines`;
  return requestApi.get(url);
};

export const getContrato = async (id: string) => {
  const url = `${API_CONSTANT_MAP.aluno}/contrato/${id}`;
  return requestApi.get(url);
};

export const getDadosAlunos = async () => {
  const url = `${API_CONSTANT_MAP.aluno}/dados-alunos`;
  return requestApi.get(url);
};
